__turbopack_context__.v({
  "component": "style-module-scss-module__bYIoSW__component",
  "date": "style-module-scss-module__bYIoSW__date",
  "image-wrapper": "style-module-scss-module__bYIoSW__image-wrapper",
  "logo": "style-module-scss-module__bYIoSW__logo",
  "text-section": "style-module-scss-module__bYIoSW__text-section",
  "title": "style-module-scss-module__bYIoSW__title",
});
